module.exports = __webpack_public_path__ + "img/10.a7a79ce7.png";